import axios from "../axiosPlugin.js";

export const getDeviceList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/device/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};
export const getDeviceDetail = (data, loading = true) => {
  return axios({
    url: "/api/device/detail/" + data.id,
    method: "get",
    data: {
      // data,
      loading,
    },
  });
};
export const deleteDevice = (data, loading = true) => {
  return axios({
    url: "/api/device/delete/" + data.id,
    method: "delete",
    data: {
      // data,
      loading,
    },
  });
};

export const updateDevice = (data, loading = true) => {
  return axios({
    url: "/api/device/update",
    method: "put",
    data: {
      data,
      loading,
    },
  });
};

export const approveDevice = (data, loading = true) => {
  return axios({
    url: "/api/device/approve?cinemaId=" + data.cinemaId,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const getPaymentTypeList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/paymentType/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getPaymentTypeListService = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/paymentType/getPaymentTypeList",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    }
  });
};

export const getPayTypeList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/payType/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getGroupList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/group/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const createGroup = (data, loading = true) => {
  return axios({
    url: "/api/group/create",
    method: "post",
    data: {
      data,
      loading,
    },
  });
};

export const updateGroup = (data, loading = true) => {
  return axios({
    url: "/api/group/update",
    method: "put",
    data: {
      data,
      loading,
    },
  });
};

export const deleteGroup = (data, loading = true) => {
  return axios({
    url: "/api/group/delete/" + data.id,
    method: "delete",
    data: {
      data,
      loading,
    },
  });
};

export const approveGroup = (data, loading = true) => {
  return axios({
    url: "/api/group/approve?cinemaId=" + data.cinemaId,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const unBound = (data, loading = true) => {
  return axios({
    url: "/api/device/updateBound?id=" + data.id,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const refreshPWD = (data, loading = true) => {
  return axios({
    url: "/api/device/genOneTimePwd?id=" + data.id,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};
